import { Component } from '@angular/core';

@Component({
	selector: 'ngx-toolbar',
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.scss'],
	standalone: false
})
export class NgxToolbarComponent {}
